/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AuthApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `AuthModule.forRoot()`
 */
export interface AuthApiConfigurationParams {
  rootUrl?: string;
}
